import { CardSnackBarComponent } from './../shared/card-snackbar/card-snackbar.component';
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { ActionMessage, TypeMessage } from '../entity/enum/enum-notification';
import { EnumForm } from '../entity/enum/enum-form';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { FormModalConfirmComponent } from '../shared/form-modal-confirm/form-modal-confirm.component';


@Injectable({
    providedIn: 'root'
})

export class NotificationService {

    public msgTime: number;
    public horizontalPosition: MatSnackBarHorizontalPosition;
    public verticalPosition: MatSnackBarVerticalPosition;

    // tslint:disable-next-line: max-line-length
    constructor(
        protected route: Router,
        protected snackBar: MatSnackBar,
        protected snackBarControl: MatSnackBar,
        public dialog: MatDialog) {
        this.msgTime = 5000;
        this.horizontalPosition = 'right';
        this.verticalPosition = 'bottom';
    }

    sendNotification(
        message?: string,
        typeMessage?: TypeMessage, actionMessage?: ActionMessage): void {
        this.snackBar.open(this.getMensagem(message, typeMessage), '', {
            duration: this.msgTime,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
            panelClass: this.getPanelClass(actionMessage)
        });
    }

    sendNotificationWithRoute(message?: string, typeMessage?: TypeMessage, actionMessage?: ActionMessage, routeDestiny?: string): void {
        const snackBarRef = this.snackBar.open(this.getMensagem(message, typeMessage), '', {
            duration: this.msgTime,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
            panelClass: this.getPanelClass(actionMessage)
        });
        snackBarRef.afterDismissed().subscribe(() => {
            this.route.navigate([`/${routeDestiny}`]);
        });
    }

    sendNotificationControl(
        message?: string,
        typeMessage?: TypeMessage,
        actionMessage?: ActionMessage,
        enumForm?: EnumForm,
        controle?: number,
        routeDestiny?: string): void {
        const snackBarRef = this.snackBar.open(this.getMensagem(message, typeMessage), '', {
            duration: this.msgTime,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
            panelClass: this.getPanelClass(actionMessage)
        });
        snackBarRef.afterDismissed().subscribe(() => {
            this.openDialog(enumForm, controle, routeDestiny);
        });
    }

    public showNotificationError(error: HttpErrorResponse, message: string, typemessage: TypeMessage = TypeMessage.Personalized): void {
        let isOnline = JSON.parse(localStorage.getItem('statusNetwork'));
        console.error(error)
        if (isOnline) {
            if (error.status === 401) {
                this.sendNotification('', TypeMessage.TokenExpired, ActionMessage.Warning);
            } else {
                this.sendNotification(message, typemessage, ActionMessage.Error);
            }
        }
    }


    public showNotification(message: string, typemessage: TypeMessage = TypeMessage.Personalized): void {
        let isOnline = JSON.parse(localStorage.getItem('statusNetwork'));
        console.log("notification: " + message)
        if (isOnline) {
            Swal.fire(message);
        }
    }





    private getPanelClass(actionMessage?: ActionMessage): string[] {
        const array: string[] = [];
        const map: Map<ActionMessage, string> = new Map<ActionMessage, string>();
        map.set(ActionMessage.Success, 'msg-success');
        map.set(ActionMessage.Error, 'msg-error');
        map.set(ActionMessage.Info, 'msg-info');
        map.set(ActionMessage.Warning, 'msg-warning');
        array.push(map.get(actionMessage));
        return array;
    }

    private getMensagem(message?: string, typeMessage?: TypeMessage): string {
        const map: Map<TypeMessage, string> = new Map<TypeMessage, string>();
        map.set(TypeMessage.New, 'Cadastro efetuado com sucesso');
        map.set(TypeMessage.Edit, 'Edição efetuado com sucesso');
        map.set(TypeMessage.Delete, 'Exclusão efetuada com sucesso');
        map.set(TypeMessage.Export, 'Exportação do arquivo efetuada com sucesso');
        map.set(TypeMessage.Token, 'Token renovado com sucesso');
        map.set(TypeMessage.TokenError, 'Token não renovado com sucesso');
        map.set(TypeMessage.TokenExpired, 'Requisição não autorizada! por favor efetue a renovação de seu token de acesso');
        map.set(TypeMessage.FormValid, 'Para salvar os campos devem estar preenchidos da forma correta, revise o formulário e tente novamente!');
        map.set(TypeMessage.Login, 'Login efetuado com sucesso');
        map.set(TypeMessage.Sync, 'Sincronização efetuada com sucesso');
        map.set(TypeMessage.SyncError, 'Erro para efetuar a sincronização dos dados');
        map.set(TypeMessage.SyncListEmpty, 'Não foi encontrado nenhuma lista de dados a ser sincronizada');
        map.set(TypeMessage.ListErrorSafra, 'Erro para buscar do banco de dados para montagem da lista de Safra');
        map.set(TypeMessage.ListErrorHibrido, 'Erro para buscar do banco de dados para montagem da lista de Hibrido');
        map.set(TypeMessage.ListErrorSiteOrigem, 'Erro para buscar do banco de dados para montagem da lista de Site de Origem');
        map.set(TypeMessage.ListErrorSiteBeneficiamento, 'Erro para buscar do banco de dados para montagem da lista de Site Beneficiamento');
        map.set(TypeMessage.ListErrorPeneira, 'Erro para buscar do banco de dados para montagem da lista de Peneira');
        map.set(TypeMessage.ListErrorTipoColheita, 'Erro para buscar do banco de dados para montagem da lista de Tipo Colheita');
        map.set(TypeMessage.ListErrorStatusSilo, 'Erro para buscar do banco de dados para montagem da lista de Status Silo');
        map.set(TypeMessage.ListErrorTurnoAmostragem, 'Erro para buscar do banco de dados para montagem da lista de Turno de Amostragem');
        map.set(TypeMessage.ListErrorConfigRolos, 'Erro para buscar do banco de dados para montagem da lista de Configuração de Rolos');
        map.set(TypeMessage.ListErrorTipoCalha, 'Erro para buscar do banco de dados para montagem da lista de Tipo de Calha');
        map.set(TypeMessage.ListErrorTipoProduto, 'Erro para buscar do banco de dados para montagem da lista de Tipo Produto');
        map.set(TypeMessage.ListErrorTipoTratamento, 'Erro para buscar do banco de dados para montagem da lista de Tipo Tratamento');
        map.set(TypeMessage.ListErrorLinhaTratamento, 'Erro para buscar do banco de dados para montagem da lista de Linha Tratamento');
        map.set(TypeMessage.ListErrorEquipUtil, 'Erro para buscar do banco de dados para montagem da lista de Equipamentos Utilizados');
        map.set(TypeMessage.ListErrorSiloOrigem, 'Erro para buscar do banco de dados para montagem da lista de Silo Origem');
        map.set(TypeMessage.CalcErrorFxUmidade, `Ocorreu um erro ao calcular a faixa azul por umidade. Entre em contato com o Administrador.`);
        map.set(TypeMessage.ListErrorNumControlClassif, 'Erro para buscar do banco de dados para montagem da lista de Número de controle classificação');
        map.set(TypeMessage.ListErrorMtvRepr, 'Erro para buscar do banco de dados para montagem da lista de Motivo Reprovação');
        map.set(TypeMessage.ListErrorNumPassRepass, 'Erro para buscar do banco de dados para montagem da lista de Número da passada - Repasse');
        map.set(TypeMessage.ListErrorLinhaReprocessamento, 'Erro para buscar do banco de dados para montagem da lista de Linha Reprocessamento');
        map.set(TypeMessage.ListErrorTurno, 'Erro para buscar do banco de dados para montagem da lista Turno');
        map.set(TypeMessage.ListErrorLoteOrigem, 'Erro para buscar do banco de dados para montagem da lista de origem');
        map.set(TypeMessage.ListErrorDepositoOrigem, 'Erro para buscar do banco de dados para montagem da lista de deposito');
        map.set(TypeMessage.ListErrorNumControl, 'Erro para buscar do banco de dados para montagem da lista de número controle');
        map.set(TypeMessage.ListErrorProcesso, 'Erro para buscar do banco de dados para montagem da lista de Processo');
        map.set(TypeMessage.ListErrorPeneiraTopo, 'Erro para buscar do banco de dados para montagem da lista de Peneira Topo');
        map.set(TypeMessage.ListErrorPeneiraFundo, 'Erro para buscar do banco de dados para montagem da lista de Peneira Fundo');
        map.set(TypeMessage.ListErrorDestino, 'Erro para buscar do banco de dados para montagem da lista de Destino');
        map.set(TypeMessage.ListErrorSiloDestino, 'Erro para buscar do banco de dados para montagem da lista de Silo Destino');
        map.set(TypeMessage.ListErrorRespTratamento, 'Erro para montar lista de responsável do tratamento');
        map.set(TypeMessage.ListErrorRespApontamento, 'Erro para montar lista de responsável do apontamento');
        map.set(TypeMessage.FormInvalid, 'Preencha todos os campos obrigatórios');
        map.set(TypeMessage.Personalized, message);
        map.set(TypeMessage.ListErrorGeneration, 'Erro para montar lista de geração');
        map.set(TypeMessage.InvalidRangeDate, 'A data final precisa ser maior ou igual a inicial,  insira novamente  ');
        map.set(TypeMessage.InvalideRangeHour, 'O Horário final precisa ser maior ou igual a inicial,  insira novamente ');
        map.set(TypeMessage.ListErrorSocidisco, 'Erro para buscar do banco de dados para montagem da lista de Socidisco');
        map.set(TypeMessage.ListErrorApollo, 'Erro para buscar do banco de dados para montagem da lista de Apollo');
        map.set(TypeMessage.RequiredField, 'Preenchimento do campo Descrição do Defeito obrigatório !');
        map.set(TypeMessage.CalcAlertLiquidoRegulagemCbt, 'Peso líquido para regulagem CBT200 (kg) abaixo de 9.5kg ou acima de 26kg');
        map.set(TypeMessage.DiffDias, 'Diferença de data maior que 7 dias');
        map.set(TypeMessage.ListErrorPolimero, 'Erro para buscar do banco de dados para montagem da lista de Polimero');

        return map.get(typeMessage);
    }

    private getMessageControle(enumForm: EnumForm, controle: number) {
        const map: Map<EnumForm, string> = new Map<EnumForm, string>();
        map.set(EnumForm.FormSec002, `O controle de secagem `);
        map.set(EnumForm.FormCd001PreLimpeza, `O número do controle `);
        map.set(EnumForm.FormCd001Classificacao, `O número do controle `);
        map.set(EnumForm.FormEt004, `O controle de análise `);
        let text = map.get(enumForm);
        text += `gerado foi <span class="spanColor">${controle} </span>`;
        text += 'para o registro cadastrado no sistema.'
        return text;
    }

    private getTitleMessageControle(enumForm: EnumForm) {
        const map: Map<EnumForm, string> = new Map<EnumForm, string>();
        map.set(EnumForm.FormSec002, 'Controle Secagem');
        map.set(EnumForm.FormCd001PreLimpeza, 'Número do Controle');
        map.set(EnumForm.FormCd001Classificacao, 'Número do Controle');
        map.set(EnumForm.FormEt004, 'Controle de Análise');
        return map.get(enumForm);
    }

    public async openDialog(enumForm: EnumForm, controle: number, routeDestiny: string): Promise<void> {
        const titleMessage = await this.getTitleMessageControle(enumForm);
        const message = await this.getMessageControle(enumForm, controle);
        const dialogRef = this.dialog.open(CardSnackBarComponent, {
            width: '670px',
            height: '225px',
            data: {
                titleMessage: titleMessage,
                message: message,
            },
        });
        dialogRef.afterClosed().subscribe(async data => {
            this.route.navigate([`/${routeDestiny}`]);
        });
    }


}
